import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { UserProvider } from "./context/UserContext"; // Import UserProvider
import RouteGuard from "./utils/RouteGuard";
import OwnerRegister from "./app/pages/Auth/OwnerRegister";
import CompanyRegister from "./app/pages/Auth/CompanyRegister";
import OwnerProfile from "./app/pages/OwnerPages/OwnerProfile/OwnerProfile";
import Login from "./app/pages/Auth/Login";
import VerifyEmail from "./app/pages/Auth/VerifyEmail";
import CompanyProfile from "./app/pages/CompanyPages/CompanyProfile/CompanyProfile";
import UnAuthorizedUserError from "./app/components/Errors/UnAuthorizedUserError";
import Vehicles from "./app/pages/OwnerPages/Vehicles/Vehicles";
import Campaigns from "./app/pages/CompanyPages/Campaigns/Campaigns";
import ResetPassword from "./app/components/ResetPassword";
import CompanyDashboard from "./app/pages/CompanyPages/Dashboard/CompanyDashboard";
import OwnerDashboard from "./app/pages/CompanyPages/Dashboard/OwnerDashboard";
import CampaignDetails from "./app/pages/CompanyPages/Campaigns/CampaignDetails";
import Restaurants from "./app/pages/OwnerPages/Restaurants/Restaurants";
import Screens from "./app/pages/OwnerPages/Screens/Screen";
import ScreenDetails from "./app/pages/OwnerPages/Screens/ScreenDetails";
import AddRestaurant from "./app/pages/OwnerPages/Restaurants/AddRestaurant";
import RestaurantDetails from "./app/pages/OwnerPages/Restaurants/RestaurantDetails";
import AddCampaign from "./app/pages/CompanyPages/Campaigns/AddCompaigns";
import EntertainmentVedios from "./app/pages/OwnerPages/EntertainmentVedios/Entertainementvideo";
import EntertainmentVideosDetails from "./app/pages/OwnerPages/EntertainmentVedios/EntertainmentVideoDetails";
import AddEntertainmentVideos from "./app/pages/OwnerPages/EntertainmentVedios/AddEntertainmentVideos";
function App() {
  return (
    <UserProvider>
      {" "}
      {/* Wrap everything inside UserProvider */}
      <Router>
        <Routes>
          <Route path="/ownersignup" element={<OwnerRegister />} />
          <Route path="/companysignup" element={<CompanyRegister />} />
          <Route path="/" element={<Login />} />
          <Route
            path="/companydashboard"
            element={
              <RouteGuard allowedRoles={["client", "partner"]}>
                <CompanyDashboard />
              </RouteGuard>
            }
          />
          <Route
            path="/ownerdashboard"
            element={
              <RouteGuard allowedRoles={["client", "partner"]}>
                <OwnerDashboard />
              </RouteGuard>
            }
          />
          <Route path="/ownerprofile" element={<OwnerProfile />} />
          <Route path="/companyprofile" element={<CompanyProfile />} />
          <Route path="/mobileLocations" element={<Vehicles />} />
          <Route path="/screens" element={<Screens />} />
          <Route path="/screendetails/:id" element={<ScreenDetails />} />
          <Route path="/fixedLocations" element={<Restaurants />} />
          <Route path="/fixedLocations/add" element={<AddRestaurant />} />
          <Route path="/fixedLocations/edit/:id" element={<AddRestaurant />} />
          <Route
            path="/restaurants/details/:id"
            element={<RestaurantDetails />}
          />
          <Route path="/campaigns" element={<Campaigns />} />
          <Route path="/campaigns/add" element={<AddCampaign />} />
          <Route path="/campaigns/edit/:id" element={<AddCampaign />} />
          <Route path="/campaigndetails/:id" element={<CampaignDetails />} />
          <Route path="/notfound" element={<UnAuthorizedUserError />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />
          <Route path="/verifyEmail/:token" element={<VerifyEmail />} />
          <Route path="/infotainmentvideos" element={<EntertainmentVedios />} />
          <Route
            path="/infotainmentvideos/:id"
            element={<EntertainmentVideosDetails />}
          />
          <Route
            path="/infotainmentvideos/add"
            element={<AddEntertainmentVideos />}
          />
          <Route
            path="/infotainmentvideos/edit/:id"
            element={<AddEntertainmentVideos />}
          />
        </Routes>
      </Router>
    </UserProvider>
  );
}

export default App;
